import { HsvColorManager } from "./HsvColorManager.js";
import { addColorManager } from "@tsparticles/engine";
export function loadHsvColorPlugin() {
    addColorManager(new HsvColorManager());
    return Promise.resolve();
}
